module.exports = __webpack_public_path__ + "static/media/sudoku1.597bb70b.png";